// TODO: bay 后续不会关心具体的业务接口，这里的内容后续会移除，由外部配置
import { injectable, singleton } from '@wakeadmin/framework';
import { BaseRepoImplement } from '@/base';

import { TreeNodeRaw } from './tree';
import { RoleInfo, SessionInfo, AppInfo, IndustryInfo } from './session';

declare global {
  interface DIMapper {
    'DI.bay.BayRepo': BayRepo;
  }
}

interface SessionData {
  userId: string;
  userName: string;
  userPhone: string;
  employeeId: number;
  domainId: number;
  buId: number;
  buName: string;
  tenantAdmin: boolean;
  roleList: RoleInfo[];
  selectRole: RoleInfo;
  selectApp: AppInfo & IndustryInfo;
  other: {
    /**
     * 当前身份id
     */
    curChooseOrgId: number;
  };
}

const MOCK_ENABLED = '[%= typeof mockEnabled !== "undefined" ? mockEnabled : "" %]' as string;

/**
 * 菜单获取接口
 */
@injectable()
@singleton()
export class BayRepo extends BaseRepoImplement {
  /**
   * 获取所有菜单
   * @returns
   */
  async getMenus() {
    if (MOCK_ENABLED === 'true') {
      return (await import('./tree/__fixture__/menu')).default;
    }

    const menus = await this.requestor.requestByPost<TreeNodeRaw[]>(
      '/permission/web/wd/menu/show/menu',
      {
        // 根节点为 0
        menuIdList: [0],
        allChildren: true,
      },
      {
        headers: { 'content-Type': 'application/x-www-form-urlencoded' },
      }
    );

    const sorter = (a: TreeNodeRaw, b: TreeNodeRaw) => (a.seq ?? 1000) - (b.seq ?? 1000);

    // 原地排序
    const sort = (list: TreeNodeRaw[]) => {
      list.sort(sorter);
      list.forEach(item => {
        if (item.childMenu?.length) {
          sort(item.childMenu);
        }
      });
    };

    sort(menus);

    return menus;
  }

  /**
   * 获取会话信息
   * @returns
   */
  async getSessionInfo(): Promise<SessionInfo> {
    const { selectApp, selectRole, roleList, other, ...others } =
      MOCK_ENABLED === 'true'
        ? (await import('./session/__fixtures__/session')).default
        : await this.requestor.requestByGet<SessionData>('/wd/employee/web/login/query');

    return {
      appInfo: selectApp,
      industryInfo: selectApp,
      userInfo: {
        ...others,
        curChooseOrgId: (other as SessionData['other'])?.curChooseOrgId,
        roles: roleList,
        currentRole: selectRole,
      },
    };
  }

  /**
   * 退出登录
   */
  async logout(): Promise<void> {
    try {
      await this.requestor.requestByGet('/permission/web/wd/login/logout');
    } catch (err) {
      // 忽略错误，无所谓
      console.error(`[bay] 退出登录失败:`, err);
    }
  }

  /**
   * 查询当前员工身份
   */
  async getCurrentEmployeeIdentityList(): Promise<{ orgId: number; orgName: string }[]> {
    return await this.requestor.requestByGet('/wd/employee/web/employee/getCurrentEmployeeIdentityList');
  }

  /**
   * 切换身份
   */
  async switchOrg(orgId: number): Promise<void> {
    try {
      await this.requestor.requestByPost(`/wd/employee/web/employee/switch/organization?orgId=${orgId}`);
    } catch (err) {
      console.error(`[bay] 切换身份失败:`, err);
    }
  }
}
